var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
import { noteType } from './ehrNoteEnums';
export var appointmentNoteTypeLabels = (_a = {},
    _a[noteType.adultTherapyIntake] = 'Adult Therapy: Intake',
    _a[noteType.adultTherapyFollowUp] = 'Adult Therapy: Follow-up',
    _a[noteType.couplesFamilyTherapyIntake] = 'Couples/Family Therapy: Intake',
    _a[noteType.couplesFamilyTherapyFollowUp] = 'Couples/Family Therapy: Follow-up',
    _a[noteType.minorTherapyIntake] = 'Minor Therapy: Intake',
    _a[noteType.minorTherapyFollowUp] = 'Minor Therapy: Follow-up',
    _a);
export var mmAppointmentNoteTypeLabels = (_b = {},
    _b[noteType.adultMedManagementIntake] = 'Adult Medication Management: Intake',
    _b[noteType.adultMedManagementFollowUp] = 'Adult Medication Management: Follow-up',
    _b[noteType.minorMedManagementIntake] = 'Minor Medication Management: Intake',
    _b[noteType.minorMedManagementFollowUp] = 'Minor Medication Management: Follow-up',
    _b);
export var cnAppointmentNoteTypeLabels = (_c = {},
    _c[noteType.careNavigatorInitial] = 'Care Navigation: Initial',
    _c[noteType.careNavigatorFollowUp] = 'Care Navigation: Follow-up',
    _c);
export var unscheduledNoteTypeLabels = (_d = {},
    _d[noteType.providerUnscheduled] = 'Unscheduled Interaction',
    _d[noteType.careNavigatorUnscheduled] = 'Unscheduled Interaction',
    _d[noteType.medManagerUnscheduled] = 'Unscheduled Interaction',
    _d);
export var noteTypeLabels = __assign(__assign(__assign(__assign({}, appointmentNoteTypeLabels), cnAppointmentNoteTypeLabels), unscheduledNoteTypeLabels), mmAppointmentNoteTypeLabels);
